import { Component, Input } from '@angular/core';
import {
  Analyst,
  UsersService,
} from '@compumark/analyst-selection-tool-client';
import { NotificationService } from '@compumark/brand-context-components';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { first } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-analyst-admin',
  standalone: false,
  templateUrl: './analyst-admin.component.html',
  styleUrls: ['./analyst-admin.component.scss'],
})
export class AnalystAdminComponent {
  @Input() userId = '';
  protected emailId = '';

  constructor(
    private usersService: UsersService,
    private notificationService: NotificationService,
  ) {}

  saveEmail(): void {
    if (!this.emailId || this.emailId.trim() === '' || !this.userId) {
      this.showSnackbar('Please enter a valid email address.');
      return;
    }
    this.usersService
      .addAnalystData(this.createAnalystData(), this.userId)
      .pipe(first(), untilDestroyed(this))
      .subscribe({
        next: () => {
          this.showSnackbar('Analyst data saved successfully.');
        },
        error: () => {
          this.showSnackbar('Error saving user email.');
        },
      });
  }
  private showSnackbar(message: string): void {
    this.notificationService.showSnackbar(message, 'Dismiss', 1000);
  }
  private createAnalystData(): Analyst {
    return {
      userId: this.userId,
      email: this.emailId.trim(),
    };
  }
}
